module.exports = __webpack_public_path__ + "img/logo-2-54fe4c.png";